import {Component, Input, OnInit} from '@angular/core';
import {Saisine} from './saisine.model';
import {UtilsService} from '../../shared/utils/utils.service';
import {SaisineService} from './saisine.service';
import {SaisineHistory} from '../saisine-history/saisine-history.model';


@Component({
    selector: 'jhi-saisine-history',
    templateUrl: './saisine-history.component.html'
})
export class SaisineHistoryComponent implements OnInit {
    @Input() saisine: Saisine;
    saisineHistory: SaisineHistory[];
    multiSortMetaDtHistory: any[];

    constructor(
        public utilsService: UtilsService,
        public saisineService: SaisineService
    ) {}


    ngOnInit() {
        this.initSortDtHistory();
    }

    showSaisineHistory() {
        this.saisineService.getSaisineHistory(this.saisine.id).subscribe(saisineHistory => {
            this.saisineHistory = saisineHistory;
        });
    }


    initSortDtHistory() {
        this.multiSortMetaDtHistory = [];
        this.multiSortMetaDtHistory.push({field: 'date', order: -1});
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-history.component.ts